import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
const EASE = [0.23, 1, 0.32, 1] as const;
const azar = (min: number, max: number) => min + Math.random() * (max - min);

// Sube o baja de a 1 persona, siempre entre 1 y 3, para que el cambio se sienta natural.
const siguiente = (n: number): number => {
  if (n <= 1) return 2;
  if (n >= 3) return 2;
  return Math.random() < 0.55 ? 1 : 3;
};
export function LiveBuyersBar() {
  const [personas, setPersonas] = useState(1);
  const reducir = useReducedMotion();
  useEffect(() => {
    const t = window.setTimeout(() => setPersonas(siguiente), azar(4000, 9000));
    return () => window.clearTimeout(t);
  }, [personas]);
  return <div aria-live="polite" className="w-full border-b border-white/10 bg-black px-4 py-3 text-white" data-id="element-128" data-mp="4rzx7jz83o4s">
      <p className="mx-auto flex max-w-6xl items-center justify-center gap-2.5 text-sm font-medium sm:text-base" data-id="element-129" data-mp="3my4skges0t7i">
        <span className="relative flex h-2.5 w-2.5 shrink-0" aria-hidden="true" data-id="element-130" data-mp="3ry90vj5j6hmn">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-60 motion-reduce:hidden" data-id="element-131" data-mp="37d9907q1rbbw" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-green-500" data-id="element-132" data-mp="3hd03i9elxqbz" />
        </span>
        <span aria-hidden="true" data-id="element-133" data-mp="3cef2w8vg14n0">👥</span>
        <AnimatePresence mode="wait" initial={false} data-id="element-134" data-mp="3cfgmx2uft1gv">
          <motion.span key={personas} initial={{
          opacity: 0,
          y: reducir ? 0 : 4
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: reducir ? 0 : -4
        }} transition={{
          duration: 0.16,
          ease: EASE
        }} data-id="element-135" data-mp="2oob9eubyyl9q">
            {personas === 1 ? '1 persona está comprando ahora mismo' : `${personas} personas están comprando ahora mismo`}
          </motion.span>
        </AnimatePresence>
      </p>
    </div>;
}